const map = {
  //  黑名单管理
  blacklistManagement: () => import('@/views/blackList/BlacklistManagement'), // 退货申请
  //  黑名单明细管理
  blacklistDetails: () => import('@/views/blackList/BlacklistDetails') // 退货申请
}

export default map
